import * as React from 'react';

import { Loader } from 'semantic-ui-react';

interface State {
	visible: boolean;
}

export default class DelayedLoader extends React.Component<{}, State> {

	private timer: number;

	public constructor () {
		super();

		this.state = { visible: false };
	}

	componentWillMount () {
		this.timer = setTimeout(() => this.setState({visible: true}), 500);
	}

	componentWillUnmount () {
		clearTimeout(this.timer);
	}

	render () {
		return this.state.visible ? <Loader active /> : null;
	}
}


// WEBPACK FOOTER //
// ./code/project/pages/components/shared/DelayedLoader.tsx